
import { format } from "date-fns";
import { SimplifiedProject } from "@/types/Project";

export default {
  name: "ProjectCard",
  props: ["projectInfo"],
  data() {
    return {
      missingThumbnail: false as boolean,
    };
  },
  methods: {
    formatStartEnd(project: SimplifiedProject) {
      return `${format(project.planned_start, "MM/yyyy")} - ${format(
        project.planned_end,
        "MM/yyyy",
      )}`;
    },
  },
};
